import { render, staticRenderFns } from "./ACategoriaMoodlePrograma.vue?vue&type=template&id=2d3b406f"
import script from "./ACategoriaMoodlePrograma.vue?vue&type=script&lang=js"
export * from "./ACategoriaMoodlePrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports